module.exports = __webpack_public_path__ + "img/zerticarbonnft.10bc31b8.png";